module.exports = __webpack_public_path__ + "static/media/ml.7c83de39.svg";